export const config = {
  REGION: "us-east-1",
  USER_POOL_ID: "us-east-1_dfapxr4X0",
  APP_CLIENT_ID: "64fqq4bmc1q0t38ik43chmr9qv",
  // TEST_USER_NAME: "612353f8-3540-4df8-9e11-6df447143b0b",
  TEST_USER_NAME: "dboza@gmail.com",
  TEST_USER_PASSWORD: "12345a",
  APP_DOCS_BUCKET: "nevula-docs-bucket-test-12db7f23c30b",
  APP_PHOTOS_BUCKET: "nevula-images-bucket-test-12db7f23c30b"
};